import { useCallback } from 'react';
import {
  acceptanceStatusesBorderColorsMap,
  constructionBorderColorMap,
  internalAcceptanceBorderColorMap,
} from '../constants/stagesColorMaps';
import { useSelector } from 'react-redux';
import { useGetCountIndicators } from './useGetCountIndicators';

const stagesEnum = {
  acceptance: 3, // приемка
  internalAcceptance: 2, // внутренняя приемка
  construction: 1, // строительство
};

const useBorderColorStagesFlat = () => {
  const { monitoringStage, valuesRequestAttributes } = useSelector(
    (state) => state.housingStockStore
  );
  const getIndicators = useGetCountIndicators();

  const getBgColorStagesFlat = useCallback(
    (flat) => {
      const {
        stageAddressLifeCycle,
        acceptanceStatusAddressLifeCycle,
        stepAddressLifeCycle,
      } = flat?.addressLifeCycle || {};

      if (!!valuesRequestAttributes?.length) {
        const { sumDeadline, sumExpired, sumExcess } = getIndicators(
          flat.addressId
        );
        const finishType = flat?.address?.addressTypeFinishId;

        const hasColor = valuesRequestAttributes?.some((filterValue) => {
          switch (filterValue) {
            case 1:
              return !!sumDeadline;
            case 2:
              return !!sumExpired;
            case 3:
              return !!sumExcess;
            case 4:
              return finishType === 4;
            default:
              return true;
          }
        });

        if (!hasColor) return undefined;
      }

      if (
        monitoringStage === stagesEnum.construction &&
        stageAddressLifeCycle?.id === stagesEnum.construction
      ) {
        return (
          constructionBorderColorMap.get(stepAddressLifeCycle?.id) || undefined
        );
      }
      if (
        monitoringStage === stagesEnum.internalAcceptance &&
        stageAddressLifeCycle?.id === stagesEnum.internalAcceptance
      ) {
        return (
          internalAcceptanceBorderColorMap.get(stepAddressLifeCycle?.id) ||
          undefined
        );
      }
      if (monitoringStage === stagesEnum.acceptance) {
        return (
          acceptanceStatusesBorderColorsMap.get(
            acceptanceStatusAddressLifeCycle?.id
          ) || undefined
        );
      }
    },
    [monitoringStage, valuesRequestAttributes?.length, getIndicators]
  );

  return getBgColorStagesFlat;
};

export default useBorderColorStagesFlat;
